<template>
  <el-select
    v-model="selected"
    @change="inputChange"
    :size="size"
    :loading="loading"
    :placeholder="placeholder"
    :filterable="filterable"
    :clearable="clearable"
    :disabled="disabled"
    :multiple="multiple"
  >
    <el-option
      v-for="option in options"
      :value="option.value"
      :label="option.name"
      :key="option.id"
    ></el-option>
  </el-select>
</template>
<script>
import store from './dictionaryStore'
export default {
  name: 'zk-dictionary-select',
  props: {
    value: {
      type: [String, Number, Array],
      default: ''
    },
    // 使用时，也得设置 value 才行
    label: {
      type: [String, Number, Array],
      default: ''
    },
    type: {
      type: String,
      validator(value) {
        return value !== ''
      }
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: function() {
        return this.$t('common.select')
      }
    },
    filterable: {
      type: Boolean,
      default: false
    },
    size: {
      validator(value) {
        return ['small', 'large', 'default'].indexOf(value) >= 0
      }
    },
    placement: {
      validator(value) {
        return ['top', 'bottom'].indexOf(value) >= 0
      },
      default: 'bottom'
    }
  },
  data() {
    return {
      loading: false,
      options: [],
      selected:
        this.value === null || this.value === undefined ? '' : this.value + ''
    }
  },

  methods: {
    inputChange(val) {
      this.$emit('input', val)
      this.$emit('change', val)
    },
    getDicValue() {
      store.getDictsByType(this.type).then(data => {
        this.options = data
      })
    }
  },
  watch: {
    value(val) {
      if (val === null) {
        this.selected = ''
      } else {
        this.selected = val + ''
      }
    },
    selected(val) {
      this.$emit('input', val)
      this.$emit('change', val)
    }
  },
  mounted() {
    this.getDicValue()
  }
}
</script>



// WEBPACK FOOTER //
// src/cdpBase/baseComponents/dictionarySelect/dictionary-select.vue